export const pages = ['Блог', 'Помощь', 'Тарифы'] //'Тур по сервису',
export const settings = ['Мой профиль', 'Выйти']

export const LOGO_IMAGE_DATA = {
  SRC: '/images/svg/logo.svg',
  ALT: "Логотип 'Родком'"
}
